"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genomeColor = exports.updownstreamColor = exports.cdsColor = exports.proteinColor = exports.utrColor = exports.intronColor = void 0;
// note that these are currently put into the style section instead of being
// defined in classes to aid copy and paste to an external document e.g. word
exports.intronColor = undefined;
exports.utrColor = 'rgb(200,240,240)';
exports.proteinColor = 'rgb(220,160,220)';
exports.cdsColor = 'rgb(220,220,180)';
exports.updownstreamColor = 'rgba(250,200,200)';
exports.genomeColor = 'rgb(200,280,200)';
